import React, { useContext, useEffect, useState } from "react";
import ShowPlaid from "./ShowPlaid";
import DEATH_API from "../../apis/death.api";
import BUDGET_API from "../../apis/budget.api";
import PLAID_API from "../../apis/plaid.api";
import { MODULE_API } from "../../apis";
import ListPaginated from "../styledComponents/Table/ListPaginated";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import matchImg from ".../../assets/images/DeathModuleNew/Checkbox.png";
import plaidIcon from "../../assets/images/plaidLogo1.png";
import SearchIcon from "../../assets/images/Search.svg";
import deleteIcon from "../../assets/images/DeathModuleNew/delete.png";
import assetHomeIcon from "../../assets/images/asset.png";
import debtImage from "../../assets/images/debt.png";
import networthImage from "../../assets/images/networth.png";
import warningSign from "../../assets/SVGs/warningSign.svg"
import {
  setRefreshTime,
  setRefreshTimeAsset,
} from "../../redux/slices/itemsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import moment from "moment";
import "./Plaidmain.css";
import swal from "sweetalert";
import { ProgressContext } from "../../utils/ProgressContext";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
import {
  PlaidAccountsSkeleton,
  PlaidBankSearchSkeleton,
  PlaidLoadingMessage,
  PlaidButtonSpinner,
  PlaidStatusLoader,
  PlaidApiStatusSkeleton,
} from "./PlaidLoadingStates";

const PlaidMainNew = () => {
  const [link, setLink] = useState();
  const { startLoading, stopLoading, loadingProgress } =
    useContext(ProgressContext);

  const [loading, setLoading] = useState(true);
  const [bankDetails, setBankDetails] = useState([]);
  const [addbank, setAddbank] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [updatedObject, setUpdateObject] = useState(null);
  const [detailsModal, setDetailsModal] = useState(false);
  const [syncPayload, setSyncPayload] = useState([]);
  const [syncModal, setSyncModal] = useState(false);
  const [addAccountModal, setAddAccountModal] = useState(false);
  const [matchData, setMatchData] = useState(null);
  const [matchValues, setMatchValues] = useState(null);

  const [previousData, setPreviousData] = useState(null);
  const [addPlanPayload, setaddPlanPayload] = useState(null);
  const [addPlanAccountData, setAddPlanAccountData] = useState(null);
  const [dropdown, setDropdown] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [accountTypeModal, setAccountTypeModal] = useState(false);
  const [accountSelected, setAccountSelected] = useState(null);

  const [bankDetailsLatest, setBankDetailsLatest] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankDropdown, setBankDropdown] = useState(false);
  const [bankModal, setBankModal] = useState(false);
  const [bankloading, setBankLoading] = useState(false);
  const [pageLoadingState, setPageLoadingState] = useState("loadAccounts");
  const [bankLoadingState, setBankLoadingState] = useState(null);
  const [rowActionState, setRowActionState] = useState(null);
  const [bankActionState, setBankActionState] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [bankList, setBankList] = useState([]);
  const [plaidCooldown, setPlaidCooldown] = useState(null);
  const [isSyncingPlaid, setIsSyncingPlaid] = useState(false);
  const [isPlaidActivityLoading, setIsPlaidActivityLoading] = useState(false);
  const [plaidLogs, setPlaidLogs] = useState([]);
  const [plaidWebhookUpdates, setPlaidWebhookUpdates] = useState([]);
  const [currentTime, setCurrentTime] = useState(moment());
  const [manualUpdateAccountId, setManualUpdateAccountId] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );

  const startPageLoading = (state) => {
    setPageLoadingState(state);
    setLoading(true);
  };

  const stopPageLoading = () => {
    setLoading(false);
    setPageLoadingState(null);
  };

  const startBankLookupLoading = (state) => {
    setBankLoadingState(state);
    setBankLoading(true);
  };

  const stopBankLookupLoading = () => {
    setBankLoading(false);
    setBankLoadingState(null);
  };

  const startRowAction = (accountId, action, label) => {
    setRowActionState({
      accountId,
      action,
      label,
    });
  };

  const stopRowAction = () => {
    setRowActionState(null);
  };

  const startBankAction = (bankName, action, label) => {
    setBankActionState({
      bankName,
      action,
      label,
    });
  };

  const stopBankAction = () => {
    setBankActionState(null);
  };

  const formatLiveCooldownTime = (totalSeconds) => {
    if (totalSeconds === null || totalSeconds === undefined) {
      return "";
    }

    const safeSeconds = Math.max(0, totalSeconds);
    const hours = Math.floor(safeSeconds / 3600);
    const minutes = Math.floor((safeSeconds % 3600) / 60);
    const seconds = safeSeconds % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    }

    if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }

    return `${seconds}s`;
  };

  const getResponseData = (response) => {
    if (response && Array.isArray(response.data)) {
      return response.data;
    }

    if (response && response.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }

    return [];
  };

  const formatApiName = (apiName) => {
    if (!apiName) {
      return "Plaid API";
    }

    const normalizedName = apiName
      .replace(/_/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    const readableName =
      normalizedName === normalizedName.toUpperCase()
        ? normalizedName.toLowerCase()
        : normalizedName.replace(/([A-Z])/g, " $1");

    return readableName
      .replace(/\s+/g, " ")
      .trim()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatPlaidDateTime = (dateTime) => {
    const formattedMoment = dateTime ? moment(dateTime) : null;

    return formattedMoment && formattedMoment.isValid()
      ? formattedMoment.local().format("MM/DD/YYYY [at] hh:mmA")
      : null;
  };

  const getPlaidUpdateErrorMessage = (responseData, fallbackMessage) => {
    const coolingPeriodExpiresAt =
      responseData && responseData.coolingPeriodExpiresAt;
    const formattedCoolingPeriod = formatPlaidDateTime(coolingPeriodExpiresAt);

    if (formattedCoolingPeriod) {
      return `Deep sync blocked: cooling period active until ${formattedCoolingPeriod}.`;
    }

    if (fallbackMessage) {
      return fallbackMessage.replace(
        /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z/g,
        (dateTime) => formatPlaidDateTime(dateTime) || dateTime
      );
    }

    return "Please try again in a moment.";
  };

  const getLatestLogByType = (logs, type) => {
    const typeNeedle = type.toLowerCase();

    return logs
      .filter((log) => log && log.api && log.api.toLowerCase().includes(typeNeedle))
      .sort((firstLog, secondLog) =>
        moment(secondLog.createdAt).valueOf() - moment(firstLog.createdAt).valueOf()
      )[0];
  };

  const normalizePlaidCooldownResponse = (response) => {
    if (Array.isArray(response)) {
      return response;
    }

    if (response && Array.isArray(response.data)) {
      return response.data;
    }

    if (response && response.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }

    return [];
  };

  const getLatestPlaidTimestamp = (record) => {
    if (!record) {
      return null;
    }

    return (
      record.lastSuccessfulSync ||
      record.bankSignalTime ||
      record.updatedAt ||
      record.createdAt ||
      null
    );
  };

  const getPlaidCooldownStatus = (record) => {
    const cooldownExpiresAt =
      record && (record.seatCooldownExpiresAt || record.coolingPeriodExpiresAt);
    const cooldownMoment = cooldownExpiresAt ? moment(cooldownExpiresAt) : null;
    const hasActiveCooldown =
      cooldownMoment && cooldownMoment.isValid() && cooldownMoment.isAfter(currentTime);

    const latestTimestamp = getLatestPlaidTimestamp(record);
    const lastCallMoment = latestTimestamp ? moment(latestTimestamp) : null;

    return {
      lastCall:
        lastCallMoment && lastCallMoment.isValid()
          ? lastCallMoment.local().format("MM/DD/YYYY [at] hh:mmA")
          : "No calls yet",
      remaining: hasActiveCooldown
        ? formatLiveCooldownTime(
            Math.max(0, cooldownMoment.diff(currentTime, "seconds"))
          )
        : lastCallMoment && lastCallMoment.isValid()
        ? "Available now"
        : "Awaiting first API call",
      isActive: hasActiveCooldown,
      expiresAt: cooldownExpiresAt || null,
      dataHealthStatus: record && record.dataHealthStatus ? record.dataHealthStatus : null,
    };
  };

  const getWebhookUpdatesForAccount = (record) => {
    if (!record) {
      return [];
    }

    const accountIds = getPlaidAccountIds(record);

    return plaidWebhookUpdates.filter(
      (update) =>
        update &&
        update.enable !== false &&
        update.deleted !== true &&
        update.accountId &&
        accountIds.includes(update.accountId)
    );
  };

  const getPlaidAccountIds = (record) => {
    if (!record) {
      return [];
    }

    return [
      record.accountId,
      record.plaidAccountId,
      record.plaid_account_id,
      record.account_id,
    ].filter(Boolean);
  };

  const handleManualWebhookUpdate = (record, update) => {
    const accountName =
      record && record.accountName ? record.accountName : "this account";
    const bankName = record && record.bankName ? record.bankName : "your bank";
    const accountId = getPlaidAccountIds(record)[0] || (update && update.accountId);
    const updateType = update && update.webhookType
      ? formatApiName(update.webhookType)
      : "Plaid";
    const updateStatus = update && update.status
      ? formatApiName(update.status)
      : "Update Available";
    const popupContent = document.createElement("div");
    const message = document.createElement("p");
    const status = document.createElement("div");
    const note = document.createElement("p");

    popupContent.className = "plaid-update-confirmation";
    message.className = "plaid-update-confirmation__message";
    message.textContent = `Plaid has a new ${updateType} update for ${accountName} at ${bankName}.`;
    status.className = "plaid-update-confirmation__status";
    status.textContent = `Update status: ${updateStatus}`;
    note.className = "plaid-update-confirmation__note";
    note.textContent = "Do you want to run a manual refresh for this account now?";
    popupContent.appendChild(message);
    popupContent.appendChild(status);
    popupContent.appendChild(note);

    swal({
      title: "Review Plaid update?",
      content: popupContent,
      icon: "info",
      buttons: ["No, later", "Yes, update"],
      dangerMode: false,
      closeOnClickOutside: true,
    }).then(async (confirmed) => {
      if (!confirmed) {
        return;
      }

      if (!accountId) {
        swal(
          "Account ID missing",
          "We could not find the Plaid account ID needed to refresh this account.",
          "error"
        );
        return;
      }

      try {
        setManualUpdateAccountId(accountId);
        const response = await PLAID_API.updatePlaidAccount({
          webhook_type: update && update.webhookType,
          status: update && update.status,
          account_id: accountId,
        });
        const responseData = response && response.data ? response.data : null;
        const responseStatus =
          responseData && responseData.status
            ? responseData.status
            : response && response.status;
        const responseMessage =
          responseData && responseData.message
            ? responseData.message
            : response && response.message;

        await fetchPlaidActivity();

        if (responseStatus === 200 || responseStatus === "SUCCESS") {
          swal(
            "Update started",
            `${accountName} is being refreshed with the latest Plaid update.`,
            "success"
          );
          await getBankDetails("refreshAccounts");
          return;
        }

        swal(
          "Deep sync blocked",
          getPlaidUpdateErrorMessage(responseData, responseMessage),
          "error"
        );
      } catch (error) {
        console.log(error);
        swal(
          "Update failed",
          "Something went wrong while starting the manual Plaid update.",
          "error"
        );
      } finally {
        setManualUpdateAccountId(null);
      }
    });
  };

  const PAGE_LOADING_COPY = {
    loadAccounts: {
      title: "Loading connected accounts",
      description: "Pulling your latest linked-bank data into the page.",
    },
    refreshAccounts: {
      title: "Updating connected accounts",
      description: "Refreshing balances and account actions in the background.",
    },
    deleteAccount: {
      title: "Deleting linked account",
      description: "Removing this bank account and refreshing the list.",
    },
    unlinkBank: {
      title: "Unlinking bank",
      description: "Disconnecting the institution and clearing synced records.",
    },
    matchAccounts: {
      title: "Finding account matches",
      description: "Checking whether this Plaid account already exists in your plan.",
    },
    loadAllocationOptions: {
      title: "Preparing account options",
      description: "Loading the Asset Planet categories for this bank account.",
    },
    addToPlan: {
      title: "Adding account to Asset Planet",
      description: "Saving the connection and updating your linked accounts.",
    },
    preparePlaidLink: {
      title: "Preparing secure bank connection",
      description: "Creating a fresh Plaid session so the bank can be linked safely.",
    },
    reauthorizeBank: {
      title: "Reconnecting bank access",
      description: "Opening Plaid so the bank can be authorized again.",
    },
  };

  const BANK_LOADING_COPY = {
    loadBanks: {
      title: "Loading banks",
      description: "Fetching institutions you can connect with Plaid.",
    },
    searchBanks: {
      title: "Searching banks",
      description: "Looking for institutions that match your search.",
    },
    loadMoreBanks: {
      title: "Loading more banks",
      description: "Fetching additional institutions for you.",
    },
  };

  const handleOpenBankModal = () => {
    setBankModal(true);
    setSearchQuery("");
    setBankList([]);
    setCurrentPage(1);
    setTotalPages(1);
    getPlaidBankList(1);
  };
  const handleCancelBankModal = () => {
    setBankModal(false);
    setTotalPages(1);
    setCurrentPage(1);
  };

  const handleOpenAccountTypeModal = () => {
    setAccountTypeModal(true);
  };
  const handleCancelAccountTypeModal = () => {
    setAccountTypeModal(false);
    setAccountSelected(null);
  };

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      document.getElementById("bankDisplay");
    console.log("Scroll Top:", scrollTop);
    console.log("Scroll Height:", scrollHeight);
    console.log("Client Height:", clientHeight);

    if (scrollTop + clientHeight >= scrollHeight) {
      console.log("Bottom of the scroll reached.");
      console.log("pageee", currentPage, totalPages);
      if (currentPage < totalPages) {
        console.log("Fetching more items...");
        getPlaidBankList(currentPage + 1);
      }
    }
  };
  const getPlaidBankList = async (page) => {
    try {
      startBankLookupLoading(page > 1 ? "loadMoreBanks" : "loadBanks");
      const response = await DEATH_API.getPlaidBanks(page);
      // Assuming the bank list is in the response.data
      if (response && response.data) {
        const updatedBankList =
          page === 1
            ? response.data.institutions
            : [...bankList, ...response.data.institutions];
        // Sort the merged bank list alphabetically by name
        const sortedInstitutions = updatedBankList.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        // Set the sorted list in state
        setBankList(sortedInstitutions);
        // const sortedInstitutions = response.data.institutions.sort((a, b) =>
        //   a.name.localeCompare(b.name)
        // );
        // setBankList((prevItems) => [...prevItems, ...response.data.institutions]);
        setTotalPages(
          Math.ceil(response.data.total && response.data.total / 50)
        );
        setCurrentPage(page);
      }
      stopBankLookupLoading();
    } catch (error) {
      stopBankLookupLoading();
      console.error("Error fetching Plaid bank list:", error);
    }
  };

  const fetchPlaidCooldown = async () => {
    try {
      const response = await BUDGET_API.fetchPlaidCooldowntime();
      const plaidCooldownRecords = normalizePlaidCooldownResponse(response);
      const latestRefresh = plaidCooldownRecords
        .map((record) => getLatestPlaidTimestamp(record))
        .filter(Boolean)
        .sort((first, second) => moment(second).valueOf() - moment(first).valueOf())[0];

      setPlaidCooldown({
        records: plaidCooldownRecords,
        lastRefresh: latestRefresh || null,
      });
    } catch (error) {
      console.log(error);
      setPlaidCooldown(null);
    }
  };

  const fetchPlaidActivity = async () => {
    try {
      setIsPlaidActivityLoading(true);
      const [logsResponse, webhookResponse] = await Promise.all([
        PLAID_API.fetchPlaidLogs(1, 50),
        PLAID_API.fetchPlaidWebhookUpdates(1, 50),
      ]);

      setPlaidLogs(getResponseData(logsResponse));
      setPlaidWebhookUpdates(getResponseData(webhookResponse));
    } catch (error) {
      console.log(error);
      setPlaidLogs([]);
      setPlaidWebhookUpdates([]);
    } finally {
      setIsPlaidActivityLoading(false);
    }
  };

  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      handleSearch(e);
    }
  };
  const hanldeAccountSelected = async (type) => {
    const products = [
      // "assets",
      "auth",
      "transactions",
      "identity",
      // "investments",
      // "liabilities",
    ];
    // Add products based on the selected type
    if (type === "Investment") {
      products.push(...["investments", "assets"]);
    } else if (type === "Liability") {
      products.push("liabilities");
    } else if (type === "Both Types") {
      products.push(...["investments", "assets", "liabilities"]);
    }
    console.log("bank", type, accountSelected);
    let matchedProducts;
    if (
      accountSelected &&
      accountSelected.name &&
      accountSelected.name === "Capital One"
    ) {
      const updatedProducts = products.filter(
        (product) => product !== "identity"
      );
      // Filter the bank products to match the updated products array
      matchedProducts = accountSelected.products.filter((product) =>
        updatedProducts.includes(product)
      );
    } else {
      matchedProducts = accountSelected.products.filter((product) =>
        products.includes(product)
      );
    }
    let payload = {
      products: matchedProducts,
      routingNumber:
        accountSelected.routing_numbers &&
        accountSelected.routing_numbers[0] &&
        accountSelected.routing_numbers[0],
      // institutionId:bank.institution_id && bank.institution_id,
    };
    console.log("paylllll", payload, accountSelected);
    setAccountTypeModal(false);
    createPlaidLinkToken(payload);
  };
  const hanldeBankSelect = async (bank) => {
    setAccountSelected(bank);
    setBankModal(false);
    handleOpenAccountTypeModal();
    setSearchQuery("");
    // const products = [
    //   "assets",
    //   "auth",
    //   "transactions",
    //   "identity",
    //   "investments",
    //   "liabilities",
    // ];

    // console.log("bank", bank);
    // let matchedProducts;
    // if (bank && bank.name && bank.name === "Capital One") {
    //   const updatedProducts = products.filter(
    //     (product) => product !== "identity"
    //   );
    //   // Filter the bank products to match the updated products array
    //   matchedProducts = bank.products.filter((product) =>
    //     updatedProducts.includes(product)
    //   );
    // } else {
    //   matchedProducts = bank.products.filter((product) =>
    //     products.includes(product)
    //   );
    // }
    // let payload = {
    //   products: matchedProducts,
    //   routingNumber:
    //     bank.routing_numbers &&
    //     bank.routing_numbers[0] &&
    //     bank.routing_numbers[0],
    //   // institutionId:bank.institution_id && bank.institution_id,
    // };
    // console.log("paylllll", payload, bank);
    // createPlaidLinkToken(payload);
    // setBankLoading(true);
    // setBankLoading(false);
  };
  const handleCancelSearch = async (e) => {
    e.preventDefault();
    setSearchQuery("");
    setBankList([]);
    getPlaidBankList(1);
  };
  const handleSearch = async (e) => {
    e.preventDefault();
    let SearchValue = searchQuery;
    try {
      startBankLookupLoading("searchBanks");
      setBankList([]);
      const response = await DEATH_API.searchBank(SearchValue);
      if (response.data) {
        setBankList(response.data.institutions);
      }
      stopBankLookupLoading();
    } catch (error) {
      stopBankLookupLoading();
      console.log(error);
    }
  };
  const isRowActionActive = (record, action) =>
    rowActionState &&
    rowActionState.accountId === record.id &&
    rowActionState.action === action;
  const cols = [
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   render: (record) => (record ? record : "N/A"),
    // },
    {
      title: "Account Name",
      dataIndex: "bankName",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        const accountUpdates = getWebhookUpdatesForAccount(record);
        const plaidAccountId = getPlaidAccountIds(record)[0];
        const isManualUpdateLoading =
          plaidAccountId && manualUpdateAccountId === plaidAccountId;

        return record.bankName ? (
          <div className="plaid-unauthorized">
            <div style={{ textAlign: "center",width:"85%" }}>
              {record.accountName && (
                <span
                  style={{
                    color: "black",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {record.accountName}
                  {accountUpdates.length > 0 && (
                    <button
                      type="button"
                      className={
                        isManualUpdateLoading
                          ? "plaid-webhook-update-badge plaid-webhook-update-badge--loading"
                          : "plaid-webhook-update-badge"
                      }
                      title={`${accountUpdates.length} new Plaid update(s) available. Review and refresh this account.`}
                      aria-label="Review Plaid account update"
                      disabled={Boolean(isManualUpdateLoading)}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (!isManualUpdateLoading) {
                          handleManualWebhookUpdate(record, accountUpdates[0]);
                        }
                      }}
                    >
                      <SyncOutlined spin={Boolean(isManualUpdateLoading)} />
                    </button>
                  )}
                </span>
              )}
              <div>{record.bankName}</div>
            </div>
             {record.accountStatus && record.accountStatus === "Unauthorized" &&
            <button
                style={{ background: "transparent", border: "none",width:"12%" }}
                disabled={isRowActionActive(record, "reauthorize")}
                onClick={() => authorizeBank(record)}
              >
                <img src={warningSign} alt="Unauthorized warning" />
              </button>
            }
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Account Type",
      dataIndex: "subType",
      render: (record) =>
        record
          ? record
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
          : "N/A",
    },
    {
      title: "Account Number",
      dataIndex: "mask",
      render: (record) => (record ? "****" + record : "N/A"),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      render: (record) =>
        record
          ? "$" +
            record
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "$0.00",
      // render: (record) => (record && record
      //   ? !isNaN(record)
      //     ? `${
      //         "$" +
      //         record
      //           .toFixed(2)
      //           .toString()
      //           .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      //       }`
      //     : "N/A"
      //   : "N/A"),
    },
    {
      title: "Match Found",
      dataIndex: "matchFound",
      render: (fileName, record) => {
        return record.status !== "Added to Plan" &&
          record.matchFound &&
          record.count > 0 ? (
          <div>
            <img
              style={{
                cursor: isRowActionActive(record, "matching")
                  ? "not-allowed"
                  : "pointer",
                marginLeft: "1rem",
                opacity: isRowActionActive(record, "matching") ? 0.55 : 1,
              }}
              src={matchImg}
              alt="matchImg"
              height={30}
              width={30}
              onClick={() => {
                if (!isRowActionActive(record, "matching")) {
                  syncSinglePlaid(record.bankName, record.mask);
                }
              }}
            ></img>
            {record.count && <span>{record.count}</span>}
          </div>
        ) : null;
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (fileName, record) => {
    //     return record.status ? (
    //       <button
    //         className="saveStatusbutton"
    //         style={{
    //           width: "100%",
    //           background:
    //             (record.status === "Exist in Plan" && "#E13C25") ||
    //             (record.status === "Up To Date" && "#09A84D"),
    //         }}
    //         onClick={() => {
    //           if (record.status === "Add New Account") {
    //             setSelectedIndex(record.id);
    //             addAccountToPlaid(record.subType);
    //           }
    //         }}
    //       >
    //         {record.status}
    //       </button>
    //     ) : null;
    //   },
    // },
    {
      title: "Status",
      dataIndex: "status",
      render: (fileName, record) => {
        return record.status ? (
          <div
            className="plaid-status-cell"
            style={{
              width: "100%",
              fontWeight: "bold",
              color:
                (record.status === "Exist in Plan" && "#E13C25") ||
                (record.status === "Up To Date" && "#09A84D") ||
                (record.status === "Add New Account" && "#2a3da3"),
            }}
          >
            <div>
              {" "}
              {/*
        {(record.status === "Add New Account" && "New Account (Add Now)") || record.status}
         */}
              {record.status === "Add New Account" && "New Account (Add Now)"}
              {record.status === "Exist in Plan" && "We found a match"}
              {record.status !== "Add New Account" &&
                record.status !== "Exist in Plan" &&
                record.status}
            </div>
            {record.plaidStatus && (
              <span style={{ color: "black" }}>{record.plaidStatus}</span>
            )}
            {rowActionState && rowActionState.accountId === record.id && (
              <div className="plaid-row-progress">
                <span className="plaid-row-progress__spinner" />
                <span>{rowActionState.label}</span>
              </div>
            )}
          </div>
        ) : null;
      },
    },
    {
      title: "Add to Asset Planet?",
      dataIndex: "status",
      render: (fileName, record) => {
        return record.status
          ? (record.status === "Add New Account" ||
              record.status === "Exist in Plan") && (
              <button
                className="saveStatusbutton"
                style={{
                  width: "100%",
                  opacity: rowActionState ? 0.7 : 1,
                  cursor: rowActionState ? "not-allowed" : "pointer",
                  // background:
                  //   (record.status === "Exist in Plan" && "#E13C25") ||
                  //   (record.status === "Up To Date" && "#09A84D"),
                }}
                disabled={Boolean(rowActionState)}
                onClick={() => {
                  if (
                    !rowActionState &&
                    (record.status === "Add New Account" ||
                      record.status === "Exist in Plan")
                  ) {
                    setSelectedIndex(record.id);
                    addAccountToPlaid(record.subType);
                    setSelectedStatus(record.status);
                  }
                }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {isRowActionActive(record, "loadingOptions") || isRowActionActive(record, "addingToPlan") ? (
                    <PlaidButtonSpinner />
                  ) : null}
                  {isRowActionActive(record, "loadingOptions")
                    ? "Loading..."
                    : isRowActionActive(record, "addingToPlan")
                    ? "Adding..."
                    : "ADD"}
                </div>
              </button>
            )
          : null;
      },
    },
    // {
    //   title: "Add to Asset Planet",
    //   dataIndex: "status",
    //   render: (fileName, record) => {
    //     return (
    //       <div style={{ display: "flex", justifyContent: "center" }}>
    //         {record.status && record.status === "Exist in Plan" && (
    //           <button
    //             className="saveStatusbutton"
    //             onClick={() => {
    //               addAssetToPlan(record.id);
    //             }}
    //             style={{ width: "fit-content", background: "#09A84D" }}
    //           >
    //           </button>
    //         )}
    //         {record.status && record.status === "Add New Account" && (
    //           <button
    //             className="saveStatusbutton"
    //             onClick={() => {
    //               addAssetToPlan(record.id);
    //             }}
    //             style={{ width: "fit-content" }}
    //           >
    //             Add
    //           </button>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: "Transaction Details",
    //   render: (record, index) => {
    //     return (
    //       <div key={index}>
    //         {" "}
    //         <img
    //           style={{ cursor: "pointer", marginLeft: "1rem" }}
    //           src={moreIcon}
    //           alt="moreIcon"
    //           onClick={() => {
    //             console.log("recode", record.id);
    //             getSelectedRow(record.id);
    //           }}
    //         ></img>{" "}
    //       </div>
    //     );
    //   },
    // },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                console.log("recode", record.id);
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor:
                  rowActionState || isRowActionActive(record, "deleting")
                    ? "not-allowed"
                    : "pointer",
                marginRight: "1rem",
                padding: "8px 16px",
                opacity:
                  rowActionState || isRowActionActive(record, "deleting")
                    ? 0.5
                    : 1,
              }}
            >
              <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        if (!rowActionState) {
                          deleteSelectedRow(record.id);
                          setDropdown(false);
                        }
                      }}
                    >
                      {isRowActionActive(record, "deleting")
                        ? "Deleting..."
                        : "Delete"}
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    console.log("link", link);
  }, [link]);
  useEffect(() => {
    const timerInterval = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    return () => clearInterval(timerInterval);
  }, []);
  useEffect(() => {
    getBankDetails();
    fetchPlaidCooldown();
    fetchPlaidActivity();
  }, []);
  useEffect(() => {
    if (addbank !== null) {
      console.log("adding bank");
      getBankTransactions();
    }
  }, [addbank]);
  const getBankTransactions = async () => {
    await getBankDetails("refreshAccounts");
    // await getUserTransactions();
  };
  const getUserTransactions = async () => {
    try {
      startPageLoading("refreshAccounts");
      let data = await DEATH_API.getBankAccountDetails();
      stopPageLoading();
    } catch (error) {
      console.log(error);
      stopPageLoading();
    }
  };
  const getSelectedRow = async (id) => {
    setSelectedIndex(id);
    // try {
    //   setLoading(true);
    //   let data = await DEATH_API.getBankAccountDetails(id);
    //   if (data && data.data) {
    //     setUpdateObject(data.data);
    //   }
    //   setLoading(false);
    // } catch (error) {
    //   console.log(error);
    //   setLoading(false);
    // }
    // setDetailsModal(true);
  };

  const addAssetToPlan = async () => {
    setSyncModal(false);

    const plaidModule =
      matchData && matchData.find((item) => item.managedBy === "Plaid");

    const plaidModuleName = plaidModule ? plaidModule.module.name : null;
    console.log("addPlanPayload", addPlanPayload, plaidModuleName);
    swal({
      title: "Are you sure?",
      content: {
        element: "div",
        attributes: {
          innerHTML: `Are you sure you want to ${
            plaidModuleName
              ? `unlink <strong>${plaidModuleName}</strong> and Link <strong>${
                  addPlanPayload && addPlanPayload.moduleName
                }</strong>?`
              : `Link <strong>${
                  addPlanPayload && addPlanPayload.moduleName
                }</strong>?`
          }`,
        },
      },
      // text: `Are you sure you want to ${plaidModuleName ? `unlink ${plaidModuleName} and Link ${addPlanPayload && addPlanPayload.moduleName}?` :`Link ${addPlanPayload && addPlanPayload.moduleName}?`}`,
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Link it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          startPageLoading("addToPlan");
          let data = await DEATH_API.addToPlan({
            id: addPlanPayload && addPlanPayload.id,
            clientModuleId: addPlanPayload && addPlanPayload.clientModuleId,
            atp: "no",
          });
          if (data && data.status === 200) {
            await getBankDetails();
            swal("Success", data.message, "success");
          }
          if (data.status === 400) {
            if (data.message == "PLAID_ITEM_LOGIN_REQUIRED") {
              try {
                // setLoading(true);
                setLink(null);
                let data = await DEATH_API.createPlaidLinkToken(
                  addPlanPayload.id && addPlanPayload.id
                );
                if (data.data) {
                  setLink(data.data.link_token);
                }
                // setLoading(false);
              } catch (error) {
                console.log(error);
                // setLoading(false);
              }
            } else {
              swal("Oops!", data.message, "error");
            }
            // swal("Oops!", data.message, "error");
          }
          // if (data && data.data) {
          //   setUpdateObject(data.data);
          // }
          stopPageLoading();
        } catch (error) {
          console.log(error);
          stopPageLoading();
        }
      } else {
        swal("Cancelled", "Your Account is safe :)", "error");
      }
    });

    // try {
    //   setLoading(true);
    //   let data = await DEATH_API.addToPlan({
    //     id: addPlanPayload && addPlanPayload.id,
    //     clientModuleId: addPlanPayload && addPlanPayload.clientModuleId,
    //     atp:"no",
    //   });
    //   if(data && data.status===200){
    //     await getBankDetails();
    //     swal("Success", data.message, "success")
    //   }
    //   if(data.status===400){
    //     swal("Oops!", data.message, "error")
    //   }
    //   // if (data && data.data) {
    //   //   setUpdateObject(data.data);
    //   // }
    //   setLoading(false);
    // } catch (error) {
    //   console.log(error);
    //   setLoading(false);
    // }
    setaddPlanPayload(null);
  };

  // const syncAllPlaid = async () => {
  //   try {
  //     setLoading(true);
  //     let data = await DEATH_API.syncAllPlaidRecords(
  //       syncPayload && syncPayload
  //     );
  //     await refreshDataPlaid();
  //     if (data && data.status === 200) {
  //       await getBankDetails();
  //     }
  //     if (data && data.status === 400) {
  //       await getBankDetails();
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  // sync

  const syncAllPlaid = async () => {
    if (
      isPlaidCooldownActive ||
      isBusy ||
      isSyncingPlaid ||
      (syncPayload && syncPayload.length === 0)
    ) {
      return;
    }

    try {
      setIsSyncingPlaid(true);
      const interval = startLoading();

      let data = await DEATH_API.syncAllPlaidRecords(syncPayload);

      await refreshDataPlaid();
      if (data && data.status === 200) {
        setPlaidCooldown((prevState) => ({
          ...(prevState || {}),
          lastRefresh: new Date().toISOString(),
        }));
        await getBankDetails("refreshAccounts");
      }
      if (data && data.status === 400) {
        await getBankDetails("refreshAccounts");
      }
      clearInterval(interval);
      stopLoading();
      await fetchPlaidCooldown();
      await fetchPlaidActivity();
    } catch (error) {
      console.log(error);
      stopLoading(0);
      await fetchPlaidCooldown();
      await fetchPlaidActivity();
    } finally {
      setIsSyncingPlaid(false);
    }
  };

  const syncPlaidRecords = async () => {
    try {
      startPageLoading("refreshAccounts");
      let response = await DEATH_API.getBankDetails();
      let obj = [];
      if (response && response.data) {
        response.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }

      let data = await DEATH_API.syncAllPlaidRecords(obj && obj);
      // if (data && data.status === 200) {
      //   await getBankDetails();
      // }
      // if (data && data.status === 400) {
      //   await getBankDetails();
      // }
      stopPageLoading();
    } catch (error) {
      console.log(error);
      stopPageLoading();
    }
  };
  const refreshAssetModule = async () => {
    try {
      // setLoading(true);
      const response = await MODULE_API.refreshAssetModule();
      if (
        response &&
        response.status === 200 &&
        response.updatedAt &&
        response.updatedAt
      ) {
        dispatch(setRefreshTimeAsset(response.updatedAt));
      }
      // console.log("response",response)
      // if(response && response.status===429){
      //   swal("Oops!",response.message,"error");
      // }
      stopPageLoading();
    } catch (error) {
      stopPageLoading();
      console.error("Error fetching user data:", error);
    }
  };
  const refreshLiabilityModule = async () => {
    try {
      // setLoading(true);
      const response = await DEATH_API.refreshLiability();
      console.log("response refresf", response.data);
      if (
        response &&
        response.status === 200 &&
        response.updatedAt &&
        response.updatedAt.updatedAt
      ) {
        dispatch(setRefreshTime(response.updatedAt.updatedAt));
      }
      stopPageLoading();
    } catch (error) {
      stopPageLoading();
      console.error("Error fetching user data:", error);
    }
  };
  const updatePayment = () => {
    history.push("/payment");
  };
  const refreshDataPlaid = async () => {
    try {
      // setLoading(true);
      const refreshData = await DEATH_API.refreshBanksData(
        syncPayload && { accounts: syncPayload }
      );
      console.log("refreshData", refreshData);
      if (refreshData && refreshData.status === 200) {
        await refreshLiabilityModule();
        await refreshAssetModule();
      }
      if (refreshData && refreshData.status === "ERROR") {
        // swal("Oops!",refreshData.message,"error");
        swal({
          title: "Oops!",
          text: refreshData.message,
          icon: "warning",
          type: "warning",
          buttons: {
            upgrade: {
              text: "Upgrade",
              value: "upgrade",
              visible: true,
            },
            ok: {
              text: "Ok",
              value: "ok",
              visible: true,
            },
          },
        }).then((value) => {
          console.log("Button value clicked:", value); // Debugging line to show the value
          switch (value) {
            case "upgrade":
              console.log("calling upgrade");
              updatePayment();
              break;

            case "ok":
              console.log("calling ok");
              break;

            default:
              console.log("No action taken");
              break;
          }
        });
      }
      stopPageLoading();
    } catch (error) {
      console.log(error);
      stopPageLoading();
    }
  };
  const syncSinglePlaid = async (bankName, mask) => {
    try {
      const account = bankDetails.find(
        (item) => item.bankName === bankName && item.mask === mask
      );
      if (account) {
        startRowAction(account.id, "matching", "Finding account matches...");
      }
      startPageLoading("matchAccounts");
      let data = await DEATH_API.syncSinglePlaidRecord({
        bankName: bankName,
        mask: mask,
      });
      if (data && data.data && data.previousData) {
        // const matchedAccounts = data.data.filter(item =>
        //   (item.accountId === data.previousData.id) || (item.accountId === null)
        // );
        // setMatchData(matchedAccounts);
        setMatchData(data.data);
      }
      if (data && data.previousData) {
        setPreviousData(data.previousData);
      }
      if (data && data.value) {
        setMatchValues(data.value);
      }
      stopPageLoading();
    } catch (error) {
      console.log(error);
      stopPageLoading();
    }
    stopRowAction();
    setSyncModal(true);
  };

  const addAccountToPlaid = async (subType) => {
    if (
      subType === "credit card" ||
      subType === "mortgage" ||
      subType === "student" ||
      subType === "loan" ||
      subType === "auto" ||
      subType === "business" ||
      subType === "commercial" ||
      subType === "construction" ||
      subType === "consumer" ||
      subType === "home equity" ||
      subType === "overdraft" ||
      subType === "line of credit"
    ) {
      try {
        startRowAction(selectedIndex, "loadingOptions", "Loading add-to-plan options...");
        startPageLoading("loadAllocationOptions");
        let data = await MODULE_API.insuraceAllocation(
          "Liabilities and Credit"
        );
        if (data) {
          setAddPlanAccountData(data);
        }

        stopPageLoading();
      } catch (error) {
        console.log(error);
        stopPageLoading();
      }
    } else {
      try {
        startRowAction(selectedIndex, "loadingOptions", "Loading add-to-plan options...");
        startPageLoading("loadAllocationOptions");
        let data = await MODULE_API.assetAllocation();
        if (data) {
          setAddPlanAccountData(data);
        }

        stopPageLoading();
      } catch (error) {
        console.log(error);
        stopPageLoading();
      }
    }

    setAddAccountModal(true);
    stopRowAction();
  };
  const handleAssetSelect = async (name, subType) => {
    setAddAccountModal(false);
    try {
      startRowAction(selectedIndex, "addingToPlan", "Adding account to Asset Planet...");
      startPageLoading("addToPlan");
      let data = await DEATH_API.addToPlan({
        module: name,
        subType: subType,
        id: selectedIndex && selectedIndex,
        atp:
          selectedStatus && selectedStatus === "Exist in Plan" ? "yes" : "no",
      });
      if (data && data.status === 200) {
        await getBankDetails();
        swal("Success!", data.message, "success");
      }
      if (data && data.status === 400) {
        if (data.message == "PLAID_ITEM_LOGIN_REQUIRED") {
          try {
            // setLoading(true);
            setLink(null);
            let data = await DEATH_API.createPlaidLinkToken(
              selectedIndex && selectedIndex
            );
            if (data.data) {
              setLink(data.data.link_token);
            }
            // setLoading(false);
          } catch (error) {
            console.log(error);
            // setLoading(false);
          }
        } else {
          swal("Oops!", data.message, "error");
        }
        // swal("Oops!", data.message, "error")
      }
      // if (data && data.data) {
      //   setUpdateObject(data.data);
      // }
      stopPageLoading();
    } catch (error) {
      console.log(error);
      stopPageLoading();
    }
    stopRowAction();
  };

  const handleCancel = () => {
    setDetailsModal(false);
    setUpdateObject(null);
  };
  const handleCancelAdd = () => {
    setAddAccountModal(false);
  };
  const handleCancelSyncModal = () => {
    setSyncModal(false);
    setMatchData(null);
    setMatchValues(null);
    setPreviousData(null);
    setaddPlanPayload(null);
  };
  const createPlaidLinkToken = async (payload) => {
    try {
      startPageLoading("preparePlaidLink");
      setLink(null);
      let data = await DEATH_API.createPlaidLinkToken(null, payload);
      if (data.data) {
        setLink(data.data.link_token);
      }
      stopPageLoading();
    } catch (error) {
      console.log(error);
      stopPageLoading();
    }
  };
  const authorizeBank = async (payload) => {
    try {
      startRowAction(payload.id, "reauthorize", "Preparing bank reconnection...");
      startPageLoading("reauthorizeBank");
      setLink(null);
       let data = await DEATH_API.createPlaidLinkToken(
        payload.id && payload.id
        );
       if (data.data) {
        setLink(data.data.link_token);
       }
       stopPageLoading();
      } catch (error) {
        console.log(error);
        stopPageLoading();
     }
    stopRowAction();
  };
  const deleteSelectedRow = async (idx) => {
    console.log("index of deleted", idx);
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this account from your Plan?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          startRowAction(idx, "deleting", "Deleting linked account...");
          startPageLoading("deleteAccount");
          await DEATH_API.DeletePlaidAccount(idx);
          await getBankDetails("deleteAccount");
        } catch (error) {
          console.log(error);
          stopPageLoading();
        }
        stopRowAction();
        setTimeout(async () => {
          swal("Deleted!", "Your Account has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Account is safe :)", "error");
      }
    });
  };
  function findBankIdsByBankName(data, bankName) {
    const bankIds = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].bankName === bankName) {
        bankIds.push(data[i].id);
      }
    }
    return bankIds;
  }
  const deleteAllBanks = async (name) => {
    console.log("index of deleted", name, bankDetails);
    let bankIds = findBankIdsByBankName(bankDetails, name);
    console.log("bankIds", bankIds);
    swal({
      title: "Are you sure you want to Unlink?",
      text: "1. Your subscription status will not change. You may continue to be billed on this account. \n 2. Custom categories and edits will be permanently deleted. \n 3. All historical data will be permanently deleted.\n 4. Alerts on this account will be turned off.",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Unlink it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          startBankAction(name, "unlinking", "Unlinking bank and removing accounts...");
          startPageLoading("unlinkBank");
          await DEATH_API.DeleteAllAccount(name, bankIds);
          await getBankDetails("unlinkBank");
        } catch (error) {
          console.log(error);
          stopPageLoading();
        }
        stopBankAction();
        setTimeout(async () => {
          swal("Deleted!", "Your accounts have been deleted.", "success");
        }, 0);
      } else {
        stopBankAction();
        swal("Cancelled", "Your Accounts are safe :)", "error");
      }
    });
  };

  const getBankDetails = async (loadingType = "loadAccounts") => {
    try {
      if (!loadingProgress) {
        startPageLoading(loadingType);
      }
      let data = await DEATH_API.getBankDetails();
      setSyncPayload([]);
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        data.data.forEach((item) => {
          if (!bankData[item.bankName]) {
            bankData[item.bankName] = [];
          }
          bankData[item.bankName].push({
            ...item,
            bankName: item.bankName,
            mask: item.mask,
          });
        });

        console.log("datadatata", bankData);
        setBankDetailsLatest(bankData);

        setBankDetails(data.data);
        data.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }
      console.log("objobj", obj);
      setSyncPayload((prevState) => [...prevState, ...obj]);
      stopPageLoading();
    } catch (error) {
      console.log(error);
      stopPageLoading();
    }
  };

  const accountTypes = [
    {
      id: 1,
      name: "Investment",
      title: "Asset",
      description: "Checking, savings, brokerage, and other asset accounts.",
      image: assetHomeIcon,
    },
    {
      id: 2,
      name: "Liability",
      title: "Credit",
      description: "Credit cards, loans, HELOCs, and other debt accounts.",
      image: debtImage,
    },
    {
      id: 3,
      name: "Both Types",
      title: "Both Types",
      description: "Connect both asset and liability accounts from this bank.",
      image: networthImage,
    },
  ];

  const hasLinkedBanks =
    bankDetailsLatest && Object.keys(bankDetailsLatest).length > 0;
  const pageLoadingContent = pageLoadingState
    ? PAGE_LOADING_COPY[pageLoadingState]
    : null;
  const bankLoadingContent = bankLoadingState
    ? BANK_LOADING_COPY[bankLoadingState]
    : null;
  const isInitialBankLoad =
    loading && pageLoadingState === "loadAccounts" && userRole !== "FreeTrail";
  const isRefreshingBankData =
    loading && !isInitialBankLoad && !loadingProgress && pageLoadingContent;
  const isBusy = loading || loadingProgress || isSyncingPlaid;
  const shouldShowPlaidApiStatusSkeleton =
    userRole !== "FreeTrail" && isPlaidActivityLoading;
  const plaidLastRefresh =
    plaidCooldown && plaidCooldown.lastRefresh ? plaidCooldown.lastRefresh : null;
  const refreshTimestamp = refreshTime || plaidLastRefresh;
  const cooldownWindowHours = 24;
  const lastRefreshMoment = plaidLastRefresh ? moment(plaidLastRefresh) : null;
  const now = currentTime;
  const hoursSinceLastSync =
    lastRefreshMoment && lastRefreshMoment.isValid()
      ? Math.max(0, now.diff(lastRefreshMoment, "hours", true))
      : null;
  const hoursUntilNextSync =
    hoursSinceLastSync !== null
      ? Math.max(0, cooldownWindowHours - hoursSinceLastSync)
      : null;
  const isPlaidCooldownActive =
    hoursUntilNextSync !== null && hoursUntilNextSync > 0;
  const isSyncDisabled =
    (syncPayload && syncPayload.length === 0) || isBusy || isPlaidCooldownActive;
  const cooldownHoursSince =
    hoursSinceLastSync !== null ? Math.floor(hoursSinceLastSync) : null;
  const cooldownSecondsRemaining =
    hoursUntilNextSync !== null
      ? Math.max(0, Math.ceil(hoursUntilNextSync * 60 * 60))
      : null;
  const formattedCooldownTime = formatLiveCooldownTime(cooldownSecondsRemaining);
  const plaidCooldownMessage =
    isPlaidCooldownActive &&
    cooldownHoursSince !== null &&
    formattedCooldownTime
      ? `Your bank data was updated ${cooldownHoursSince} hour(s) ago. Sync available in ${formattedCooldownTime}.`
      : null;
  const transactionsLog = getLatestLogByType(plaidLogs, "transaction");
  const balanceLog = getLatestLogByType(plaidLogs, "balance");
  const investmentLog = getLatestLogByType(plaidLogs, "investment");
  const liabilitiesLog = getLatestLogByType(plaidLogs, "liabilit");
  const assetLog = getLatestLogByType(plaidLogs, "asset");
  const plaidApiCards = [
    {
      label: "Transaction API",
      product: "transactions",
    },
    {
      label: "Balance API",
      product: "balance",
    },
    {
      label: "Investment API",
      product: "investments_holdings",
    },
    {
      label: "Liabilities API",
      product: "liabilities",
    },
    {
      label: "Asset API",
      product: "assets",
    },
  ];
  const plaidCooldownRecords =
    plaidCooldown && Array.isArray(plaidCooldown.records)
      ? plaidCooldown.records
      : [];
  const plaidLogsByProduct = {
    transactions: transactionsLog,
    balance: balanceLog,
    investments_holdings: investmentLog,
    liabilities: liabilitiesLog,
    assets: assetLog,
  };

  return (
    <div className="profileMain">
      <div className="plaid-header-panel">
        <div className="plaid-header-row">
          <div className="plaid-header-title-group">
            <h1 className="plaid-header-title">
              Link Bank <ToolTipCreator name={"Link Bank"} />
            </h1>
          <ModalVideo module="Link Bank" autoOpen={true} />
          </div>
          {userRole && userRole !== "FreeTrail" && (
            <div className="plaid-header-meta">
              {refreshTimestamp &&
                <span className="plaid-header-meta__updated">
                  Updated at: {moment(refreshTimestamp)
                    .local()
                    .format("MM/DD/YYYY [at] hh:mmA")}
                </span>}
              {plaidCooldownMessage && (
                <span className="plaid-header-meta__cooldown">
                  {plaidCooldownMessage}
                </span>
              )}
              <span className="plaid-header-meta__note">
                Viewing balances uses stored data. Only "Sync All Accounts"
                runs a live Plaid refresh.
              </span>
            </div>
          )}
          {userRole && userRole !== "FreeTrail" && (
            <div className="plaid-header-actions">
            <button
              className={
                isSyncDisabled
                  ? "addbuttonassets disableButton plaid-sync-button"
                  : "addbuttonassets plaid-sync-button"
              }
              disabled={isSyncDisabled}
              style={{
                background: "#09A84D",
                opacity: isSyncDisabled ? 0.7 : 1,
                cursor: isSyncDisabled ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                syncAllPlaid();
              }}
            >
              {(loadingProgress || pageLoadingState === "refreshAccounts") ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <PlaidButtonSpinner />
                  <span>Refreshing...</span>
                </div>
              ) : isPlaidCooldownActive ? (
                formattedCooldownTime
                  ? `Sync available in ${formattedCooldownTime}`
                  : "Bank Data Current"
              ) : (
                "Sync All Accounts"
              )}
            </button>
            <ToolTipCreator name="Refresh Link Bank" />
            <button
              className="addbuttonassets plaid-add-bank-button"
              disabled={isBusy}
              style={{
                opacity: isBusy ? 0.7 : 1,
                cursor: isBusy ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                // createPlaidLinkToken();
                handleOpenBankModal();
              }}
            >
              + Add Bank
            </button>
          </div>
          )}
        </div>
        {userRole && userRole !== "FreeTrail" && (
          shouldShowPlaidApiStatusSkeleton ? (
            <PlaidApiStatusSkeleton />
          ) : (
            <div className="plaid-api-status-grid">
              {plaidApiCards.map((card) => {
                const cooldownRecord = plaidCooldownRecords.find(
                  (record) => record && record.plaidProduct === card.product
                );
                const cooldownStatus = getPlaidCooldownStatus(cooldownRecord);
                const matchingLog = plaidLogsByProduct[card.product];

                return (
                  <div className="plaid-api-status-card" key={card.label}>
                    <div className="plaid-api-status-card__top">
                      <span className="plaid-api-status-card__label">
                        {card.label}
                      </span>
                      <span
                        className={
                          cooldownStatus.isActive
                            ? "plaid-api-status-card__pill plaid-api-status-card__pill--cooldown"
                            : "plaid-api-status-card__pill"
                        }
                      >
                        {cooldownStatus.isActive ? "Cooling down" : "Ready"}
                      </span>
                    </div>
                    <div className="plaid-api-status-card__meta">
                      Last call: {cooldownStatus.lastCall}
                    </div>
                    <div className="plaid-api-status-card__meta">
                      24h cooldown: {cooldownStatus.remaining}
                    </div>
                    {cooldownStatus.dataHealthStatus && (
                      <div className="plaid-api-status-card__meta">
                        Status: {cooldownStatus.dataHealthStatus}
                      </div>
                    )}
                    {matchingLog && matchingLog.api && (
                      <div className="plaid-api-status-card__api">
                        {formatApiName(matchingLog.api)}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )
        )}
      </div>
      {link && (
        <ShowPlaid
          link={link}
          tokenState={(token) => setAddbank(token)}
          syncPlaidRecords={syncPlaidRecords}
        />
      )}

      <div
        className="rolesTable"
        style={{
          marginTop: "10px",
          height: "calc(100vh - 220px)",
          overflow: "auto",
        }}
      >
        {isRefreshingBankData && pageLoadingContent && (
          <PlaidLoadingMessage
            title={pageLoadingContent.title}
            description={pageLoadingContent.description}
            progress={loadingProgress}
          />
        )}
        {/*   <div className="RolesHeader">
          <div className="RoleTitle">Bank Details</div>
        </div>
      <List cols={cols} rows={bankDetails} /> */}
        {userRole && userRole === "FreeTrail" && (
          <div className="role-based-text">
            You don't have the required permission to link a bank account in the
            Free Role, You might need an upgraded role.
          </div>
        )}
        {isInitialBankLoad && <PlaidAccountsSkeleton />}
        {!isInitialBankLoad &&
          !loading &&
          userRole !== "FreeTrail" &&
          !hasLinkedBanks && (
            <div className="plaid-empty-state">
              <h3>No linked banks yet</h3>
              <p>
                Add a bank to start syncing balances and matching accounts with
                your plan.
              </p>
            </div>
          )}
        {!isInitialBankLoad &&
          bankDetailsLatest &&
          Object.keys(bankDetailsLatest).map((bankName, index) => (
            <div
              key={index}
              className="RolesHeader"
              style={{ display: "contents" }}
            >
              <div
                className="RoleTitle"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
                onClick={() => {
                  setSelectedBank(bankName);
                }}
              >
                <span>{bankName}</span>
                {bankActionState &&
                  bankActionState.bankName === bankName &&
                  bankActionState.action === "unlinking" && (
                    <div className="plaid-row-progress plaid-row-progress--bank">
                      <span className="plaid-row-progress__spinner" />
                      <span>{bankActionState.label}</span>
                    </div>
                  )}
                <div style={{ position: "relative" }}>
                  <div
                    onClick={() => {
                      if (!bankActionState) {
                        setBankDropdown(true);
                      }
                    }}
                    style={{
                      cursor: bankActionState ? "not-allowed" : "pointer",
                      marginRight: "1rem",
                      padding: "0px 16px",
                      width: "5px",
                      opacity: bankActionState ? 0.5 : 1,
                    }}
                  >
                    <img src={menuIcon} alt="menu-icon"></img>
                  </div>
                  {bankDropdown && selectedBank === bankName && (
                    <React.Fragment>
                      <div
                        onClick={() => {
                          setBankDropdown(false);
                        }}
                        className=""
                        style={{
                          position: "fixed",
                          width: "100vw",
                          height: "100vh",
                          background: "black",
                          opacity: "0.1",
                          top: "0",
                          left: "0",
                          right: "0",
                          bottom: "0",
                          zIndex: "999",
                        }}
                      ></div>

                      <div className="dropdownBanks" style={{ zIndex: "9999" }}>
                        <ul className="dropdownul">
                          <li
                            className="liHover"
                            onClick={() => {
                              if (!bankActionState) {
                                deleteAllBanks(bankName);
                                setBankDropdown(false);
                              }
                            }}
                          >
                            {bankActionState &&
                            bankActionState.bankName === bankName &&
                            bankActionState.action === "unlinking"
                              ? "Unlinking..."
                              : "Unlink"}
                          </li>
                        </ul>
                      </div>
                    </React.Fragment>
                  )}{" "}
                </div>
              </div>
              <ListPaginated
                key={index}
                cols={cols}
                rows={bankDetailsLatest[bankName]}
              />
            </div>
          ))}
      </div>

      {detailsModal && (
        <Modal
          visible={detailsModal}
          footer={null}
          onOk={handleCancel}
          onCancel={handleCancel}
          closable={false}
          centered
        >
          <h3 className="modaltitle">Transaction Details</h3>

          <div>
            <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
              {updatedObject && updatedObject.length > 0 ? (
                <table id="clients">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody style={{}}>
                    {updatedObject &&
                      updatedObject.map((data, index) => (
                        <tr key={index}>
                          <td>{data.name}</td>
                          <td>
                            {moment(data.date).format("DD-MM-YYYY HH:mm")}
                          </td>
                          <td>{data.amount}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <h3 className="inputTitle">No data to show</h3>
              )}
            </div>
          </div>

          <div className="buttonsMain" style={{ justifyContent: "center" }}>
            <button
              className="savebutton"
              onClick={() => {
                handleCancel();
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
      {addAccountModal && (
        <Modal
          visible={addAccountModal}
          footer={null}
          onOk={handleCancelAdd}
          onCancel={handleCancelAdd}
          closable={false}
          centered
        >
          <div
            style={{
              maxHeight: "25rem",
              overflowY: "auto",
              background: "#F4F7FE",
            }}
          >
            <div className="selelctmain">
              <h3 className="selectHeading">
                {" "}
                {addPlanAccountData &&
                  addPlanAccountData.liability &&
                  "Liabilities (Loans)"}
              </h3>
              <div className="selectmain">
                {addPlanAccountData &&
                  addPlanAccountData.liability &&
                  addPlanAccountData.liability.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        console.log("item.name", item.name, item.subType);
                        handleAssetSelect(item.name, item.subType);
                      }}
                      className="selectMaincards"
                      style={{ width: "48%" }}
                    >
                      <div
                        className="selectMaincardsInner"
                        style={{ flexWrap: "nowrap" }}
                      >
                        {" "}
                        <div
                          className="selectMainImages"
                          style={{ padding: "10px" }}
                        >
                          <img
                            src={item.image}
                            height={"25px"}
                            alt={item.name}
                          />{" "}
                        </div>
                        <div className="selectMainHeader">
                          <span
                            className="selectheadingValue"
                            style={{ fontSize: "12px" }}
                          >
                            {item.name === "Real Estates"
                              ? "Real Estate"
                              : item.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <h3 className="selectHeading" style={{ marginTop: "1rem" }}>
                {addPlanAccountData && addPlanAccountData.investment
                  ? "Investment"
                  : "Credit"}
              </h3>

              <div className="selectmain">
                {addPlanAccountData &&
                  (addPlanAccountData.investment
                    ? addPlanAccountData.investment
                    : addPlanAccountData.credit
                  ).map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        handleAssetSelect(item.name, item.subType);
                      }}
                      className="selectMaincards"
                      style={{ width: "48%" }}
                    >
                      <div
                        className="selectMaincardsInner"
                        style={{ flexWrap: "nowrap" }}
                      >
                        {" "}
                        <div
                          className="selectMainImages"
                          style={{ padding: "10px" }}
                        >
                          <img
                            src={item.image}
                            height={"25px"}
                            width={"25px"}
                            alt={item.name}
                          />{" "}
                        </div>
                        <div className="selectMainHeader">
                          <span
                            className="selectheadingValue"
                            style={{ fontSize: "12px" }}
                          >
                            {item.name === "Cash"
                              ? "Cash (Checking, Savings, etc.)"
                              : item.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="buttonsMain" style={{ justifyContent: "center" }}>
            <button
              className="savebutton"
              onClick={() => {
                handleCancelAdd();
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
      {syncModal && (
        <Modal
          visible={syncModal}
          footer={null}
          onOk={handleCancelSyncModal}
          onCancel={handleCancelSyncModal}
          closable={false}
          width={620}
          centered
        >
          <h3 className="modaltitle">Match Found</h3>
          <h3 className="modaltitle" style={{ fontSize: "12px" }}>
            Which Account would you like to Consolidate with?
          </h3>
          <div style={{ marginTop: "1rem" }}>
            <h3 className="modaltitle" style={{ textAlign: "center" }}>
              New Financial Account
            </h3>
            <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
              {previousData ? (
                <table id="clients">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Account Number</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody style={{}}>
                    {previousData && (
                      <tr>
                        <td>
                          {previousData.bankName
                            ? previousData.bankName
                            : "N/A"}
                        </td>
                        <td>
                          {previousData.accountType
                            ? previousData.accountType
                            : "N/A"}
                        </td>
                        <td>
                          {previousData.mask
                            ? "****" + previousData.mask
                            : "N/A"}
                        </td>
                        <td>
                          {previousData.balance ? previousData.balance : "N/A"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                <h3 className="inputTitle">No Previous Data to Show</h3>
              )}
            </div>
          </div>

          <div style={{ marginTop: "1rem" }}>
            <h3 className="modaltitle" style={{ textAlign: "center" }}>
              Existing Asset Planet Account
            </h3>

            <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
              {matchData && matchData.length > 0 ? (
                <table id="clients">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Account Number</th>
                      <th>Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody style={{}}>
                    {matchData &&
                      matchData.map((data, index) => (
                        <tr key={index}>
                          {matchValues
                            .filter((item) => item.clientModuleId === data.id)
                            .map((item, idx) => (
                              <td key={idx}>
                                {item.valueString ? item.valueString : "N/A"}
                              </td>
                            ))}

                          <td>
                            {data.module.name &&
                            data.module.name === "Real Estates"
                              ? "Real Estate"
                              : data.module.name}
                          </td>
                          <td>
                            {data.module.attributes[0].values[0].valueString
                              ? data.module.attributes[0].values[0].valueString
                              : "N/A"}
                          </td>
                          <td>{data.amount ? data.amount : "N/A"}</td>
                          <td>
                            {" "}
                            {console.log(" data[0].managedBy", data)}
                            {data && data && data.managedBy == "Plaid" ? (
                              <button
                                className="saveStatusbutton"
                                style={{
                                  width: "fit-content",
                                  opacity: "0.4",
                                  cursor: "not-allowed",
                                  background: "#2a3da3",
                                }}
                              >
                                {data.accountId &&
                                data.accountId !== previousData.id &&
                                data.accountId &&
                                data.accountId !== null
                                  ? "Consolidated with other"
                                  : "Consolidated"}
                              </button>
                            ) : (
                              <button
                                className="saveStatusbutton"
                                onClick={() => {
                                  console.log(
                                    "previous data",
                                    previousData.id,
                                    data.id
                                  );
                                  setaddPlanPayload({
                                    id: previousData.id,
                                    clientModuleId: data.id,
                                    moduleName: data.module.name,
                                  });
                                  if (
                                    addPlanPayload &&
                                    addPlanPayload.clientModuleId === data.id
                                  ) {
                                    setaddPlanPayload(null);
                                  }
                                  // addAssetToPlan(previousData.id,data.id);
                                }}
                                style={{
                                  width: "fit-content",
                                  background:
                                    addPlanPayload &&
                                    addPlanPayload.clientModuleId === data.id
                                      ? "#09A84D"
                                      : "#2a3da3",
                                }}
                              >
                                {addPlanPayload &&
                                addPlanPayload.clientModuleId === data.id
                                  ? "Selected"
                                  : "Select"}
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <h3 className="inputTitle">No Matched to Show</h3>
              )}
            </div>
          </div>

          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancelSyncModal();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                addAssetToPlan();
                // handleCancelSyncModal();
              }}
              style={{
                opacity:
                  addPlanPayload && addPlanPayload.clientModuleId ? "1" : "0.3",
                cursor:
                  addPlanPayload && addPlanPayload.clientModuleId
                    ? "pointer"
                    : "not-allowed",
              }}
              disabled={
                addPlanPayload && addPlanPayload.clientModuleId ? false : true
              }
            >
              Consolidate
            </button>
          </div>
        </Modal>
      )}
      <Modal
        visible={accountTypeModal}
        footer={null}
        // onOk={handleCancelSyncModal}
        onCancel={handleCancelAccountTypeModal}
        closable={false}
        centered
      >
        <div className="plaid-account-type-modal">
          <h3 className="plaid-simple-modal-title">Choose Account Type</h3>
          <p className="plaid-account-type-modal__note">
            Select the bank account type you want to add
            {accountSelected && accountSelected.name
              ? ` from ${accountSelected.name}`
              : ""}. If this bank has both asset and credit accounts, choose
            {" Both Types"}.
          </p>
          <div className="plaid-account-type-modal__list">
            {accountTypes &&
              accountTypes.map((item, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => {
                    hanldeAccountSelected(item.name);
                  }}
                  className="plaid-account-type-option"
                >
                  <div className="plaid-account-type-option__icon">
                    <img src={item.image} height={"24px"} alt={item.name} />
                  </div>
                  <div className="plaid-account-type-option__content">
                    <span className="plaid-account-type-option__title">
                      {item.title}
                    </span>
                    <span className="plaid-account-type-option__text">
                      {item.description}
                    </span>
                  </div>
                  <span className="plaid-account-type-option__radio" />
                </button>
              ))}
          </div>
        </div>
        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancelAccountTypeModal();
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>

      <Modal
        visible={bankModal}
        footer={null}
        // onOk={handleCancelSyncModal}
        onCancel={handleCancelBankModal}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Banks</h3>
        <div className="plaid-bank-modal">
          <div className="plaid-bank-modal__hero">
            <div className="plaid-bank-modal__eyebrow">Secure connection</div>
            <h3 className="plaid-bank-modal__title">
              Which bank would you like to add?
            </h3>
            <p className="plaid-bank-modal__subtitle">
              Search for your institution below to begin a secure Plaid
              connection with Asset Planet.
            </p>
          </div>
          <div className="plaid-bank-modal__search-shell">
            <div className="plaid-bank-modal__search-row">
              <div className="plaid-bank-modal__search-input">
                <input
                  className="searchStyle"
                  placeholder="Search Bank"
                  onKeyPress={handleKeypress}
                  value={searchQuery && searchQuery}
                  disabled={bankloading}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    if (e.target.value === "") {
                      handleCancelSearch(e);
                    }
                  }}
                />
              </div>
              <div
                className="filterIcons plaid-bank-modal__search-action"
                onClick={bankloading ? undefined : handleSearch}
                style={{
                  opacity: bankloading ? 0.5 : 1,
                  cursor: bankloading ? "not-allowed" : "pointer",
                  justifyContent: "center",
                }}
              >
                <img src={SearchIcon} height={22} width={24} alt="icon"></img>
              </div>
              {searchQuery && searchQuery !== "" && (
                <div
                  className="filterIcons plaid-bank-modal__search-action"
                  onClick={
                    bankloading
                      ? undefined
                      : (e) => {
                          handleCancelSearch(e);
                        }
                  }
                  style={{
                    opacity: bankloading ? 0.5 : 1,
                    cursor: bankloading ? "not-allowed" : "pointer",
                    justifyContent: "center",
                  }}
                >
                  <img src={deleteIcon} height={22} width={24} alt="icon"></img>
                </div>
              )}
            </div>
            <div className="plaid-bank-modal__meta">
              <span>
                {searchQuery && searchQuery.trim() !== ""
                  ? `Search results for "${searchQuery}"`
                  : "Popular institutions"}
              </span>
              <span>
                {bankList && bankList.length > 0
                  ? `${bankList.length} bank${bankList.length > 1 ? "s" : ""}`
                  : "No banks loaded yet"}
              </span>
            </div>
          </div>
          <div className="selectmain plaid-bank-modal__results" id="bankDisplay" onScroll={handleScroll}>
            {bankloading && bankLoadingContent && (
              <PlaidLoadingMessage
                title={bankLoadingContent.title}
                description={bankLoadingContent.description}
                compact={true}
              />
            )}
            {bankloading && (!bankList || bankList.length === 0) ? (
              <PlaidBankSearchSkeleton />
            ) : bankList && bankList.length > 0 ? (
              bankList.map((item, index) => (
                <div
                  key={item.institution_id}
                  onClick={() => {
                    console.log("item.name", item);
                    hanldeBankSelect(item);
                  }}
                  className="selectMaincards plaid-bank-result-card"
                  style={{ width: "98%" }}
                >
                  <div className="selectMaincardsInner plaid-bank-result-card__inner">
                    {" "}
                    <div
                      className="selectMainImages plaid-bank-result-card__icon"
                      style={{ padding: "0px" }}
                    >
                      <img src={plaidIcon} height={48} alt={item.name} />{" "}
                    </div>
                    <div className="selectMainHeader plaid-bank-result-card__content">
                      <span
                        className="selectheadingValue"
                        style={{ fontSize: "16px" }}
                      >
                        {item.name}
                      </span>
                      <span className="plaid-bank-result-card__meta">
                        Connect securely with Plaid
                      </span>
                    </div>
                    <div className="plaid-bank-result-card__cta">
                      <span>Select</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <h3
                className="inputTitle"
                style={{ textAlign: "center", width: "100%" }}
              >
                {searchQuery ? "No banks matched your search" : "No data to show"}
              </h3>
            )}
          </div>
        </div>

        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancelBankModal();
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <PlaidStatusLoader 
        isLoading={loading && !isInitialBankLoad && !pageLoadingContent && !bankLoadingContent}
        title={pageLoadingContent ? pageLoadingContent.title : "Processing..."}
        subtitle={pageLoadingContent ? pageLoadingContent.description : "Updating your bank data."}
        progress={loadingProgress}
      />
    </div>
  );
};

export default PlaidMainNew;
